export default __webpack_public_path__ + "static/media/ic-bold.4c6eb69b.svg";